import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { includes, debounce } from 'lodash';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { createContext, Component } from '@wordpress/element';
import { focus } from '@wordpress/dom';

var _createContext = createContext(false),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;
/**
 * Names of control nodes which qualify for disabled behavior.
 *
 * See WHATWG HTML Standard: 4.10.18.5: "Enabling and disabling form controls: the disabled attribute".
 *
 * @see https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#enabling-and-disabling-form-controls:-the-disabled-attribute
 *
 * @type {string[]}
 */


var DISABLED_ELIGIBLE_NODE_NAMES = ['BUTTON', 'FIELDSET', 'INPUT', 'OPTGROUP', 'OPTION', 'SELECT', 'TEXTAREA'];

var Disabled =
/*#__PURE__*/
function (_Component) {
  _inherits(Disabled, _Component);

  function Disabled() {
    var _this;

    _classCallCheck(this, Disabled);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Disabled).apply(this, arguments));
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    _this.disable = _this.disable.bind(_assertThisInitialized(_this)); // Debounce re-disable since disabling process itself will incur
    // additional mutations which should be ignored.

    _this.debouncedDisable = debounce(_this.disable, {
      leading: true
    });
    return _this;
  }

  _createClass(Disabled, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.disable();
      this.observer = new window.MutationObserver(this.debouncedDisable);
      this.observer.observe(this.node, {
        childList: true,
        attributes: true,
        subtree: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
      this.debouncedDisable.cancel();
    }
  }, {
    key: "bindNode",
    value: function bindNode(node) {
      this.node = node;
    }
  }, {
    key: "disable",
    value: function disable() {
      focus.focusable.find(this.node).forEach(function (focusable) {
        if (includes(DISABLED_ELIGIBLE_NODE_NAMES, focusable.nodeName)) {
          focusable.setAttribute('disabled', '');
        }

        if (focusable.hasAttribute('tabindex')) {
          focusable.removeAttribute('tabindex');
        }

        if (focusable.hasAttribute('contenteditable')) {
          focusable.setAttribute('contenteditable', 'false');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["className"]);

      return createElement(Provider, {
        value: true
      }, createElement("div", _extends({
        ref: this.bindNode,
        className: classnames(className, 'components-disabled')
      }, props), this.props.children));
    }
  }]);

  return Disabled;
}(Component);

Disabled.Consumer = Consumer;
export default Disabled;
//# sourceMappingURL=index.js.map